import { URLS } from '@/lib/consts';
import { ServiceType, type ServiceURLs } from '../../types';
import { FEATURES_AND_BENEFITS_SECTION_ID } from '../Features/consts';

/*
 * Hero Section Identifiers
 */
export const HERO_SECTION_ID = 'hero';
export const CTA_BUTTON_TEXT = 'Request A Consultation';
export const SECONDARY_BUTTON_TEXT = 'Learn More...';
export const HERO_HREF = `#SECTION-${FEATURES_AND_BENEFITS_SECTION_ID}`;

/*
 * Hero Titles & Descriptions
 */
const HERO_TITLES = {
  [ServiceType.ROOT]: '',
  [ServiceType.BUILD]: `Design & Build Services in Claremore, OK`,
  [ServiceType.RENOVATE]: `Design & Renovate Services in Claremore, OK`,
} as const;

const HERO_DESCRIPTIONS = {
  [ServiceType.ROOT]: '',
  [ServiceType.BUILD]: `Custom homes, barns, cottages, shops, and bunkhouses designed and built by Cornerstone Homes in Claremore, Rogers County, and the Tulsa metro area. 20+ years of Oklahoma craftsmanship backed by a comprehensive warranty.`,
  [ServiceType.RENOVATE]: `Kitchen renovations, basement finishes, home additions, garage conversions, screened-in porches, and more—designed and renovated by Cornerstone Homes in Claremore, Rogers County, and the Tulsa metro area. 20+ years of Oklahoma craftsmanship backed by transparent budgeting and a comprehensive warranty.`,
} as const;

/*
 * Type for Hero Section Data
 */
export interface HeroConstants {
  title: string;
  description: string;
}

/*
 * Generates "Hero" Section Data
 */
function generateHeroData(serviceType: ServiceType): HeroConstants {
  return {
    title: HERO_TITLES[serviceType],
    description: HERO_DESCRIPTIONS[serviceType],
  };
}

/*
 * Hero Section Content (Mapped by URL)
 */
const ROOT_HERO_SECTION_DATA = generateHeroData(ServiceType.ROOT);
const BUILD_HERO_SECTION_DATA = generateHeroData(ServiceType.BUILD);
const RENOVATE_HERO_SECTION_DATA = generateHeroData(ServiceType.RENOVATE);

const HERO_SECTION_CONTENT: Record<ServiceURLs, HeroConstants> = {
  [URLS.SERVICES.ROOT]: ROOT_HERO_SECTION_DATA,
  [URLS.SERVICES.DESIGN_AND_BUILD]: BUILD_HERO_SECTION_DATA,
  [URLS.SERVICES.DESIGN_AND_RENOVATE]: RENOVATE_HERO_SECTION_DATA,
};

export default HERO_SECTION_CONTENT;
